import * as React from 'react';

import { computeText } from '@/locales/utils';
import { Input } from '@/components/form/Input';
import { FormattedMessage, useIntl } from 'react-intl';
import { Text } from '@/components/atoms/Text';
import { SvyButton } from '@/components/savory/SvyButton';
import { confirm } from '@/core/asyncActions/confirm';
import { useRazCustomerMutation } from '@/services/innovorder/adminTools/adminTools.endpoints';
import { FormControl, FormControls, SuccessMessage } from '../AdminTools.style';
import { safeMutate } from '@/utils/errors';
import { Form } from '@/core/form/Form';

export type RazCustomerInputs = {
    customerId: string;
    date: string;
    brandId: string;
};

const RazCustomer: React.FunctionComponent = () => {
    const intl = useIntl();

    const [razCustomer, { isSuccess }] = useRazCustomerMutation();

    const handleSubmitForm = async ({ customerId, date, brandId }: RazCustomerInputs) => {
        const hasConfirmed = await confirm(computeText(intl, 'adminTools.confirmModal.description'));
        if (hasConfirmed) {
            await safeMutate(
                razCustomer({
                    customerId,
                    brandId,
                    date,
                }),
            );
        }
    };

    return (
        <Form<RazCustomerInputs>>
            {({ handleSubmit }) => {
                return (
                    <>
                        <Text type="large" text="brand.adminTools.razCustomer.title" />
                        <Text text="brand.adminTools.razCustomer.description1" />
                        <FormControls>
                            <FormControl>
                                <Input
                                    name="customerId"
                                    placeholder="brand.adminTools.razCustomer.form.placeholder.customerId"
                                    labelId="brand.adminTools.razCustomer.form.customerId"
                                />
                            </FormControl>
                            <FormControl>
                                <Input
                                    name="brandId"
                                    placeholder="brand.adminTools.razCustomer.form.placeholder.brandId"
                                    labelId="brand.adminTools.razCustomer.form.brandId"
                                />
                            </FormControl>
                            <FormControl>
                                <Input
                                    name="date"
                                    placeholder="brand.adminTools.razCustomer.form.placeholder.date"
                                    labelId="brand.adminTools.razCustomer.form.date"
                                />
                            </FormControl>
                            <SvyButton onClick={handleSubmit(handleSubmitForm)}>
                                <FormattedMessage id="button.validate" />
                            </SvyButton>
                            {isSuccess && <SuccessMessage text="brand.adminTools.razCustomer.form.success" />}
                        </FormControls>
                    </>
                );
            }}
        </Form>
    );
};

export default RazCustomer;
